import React from 'react'
import './Works.css'
// import Upwork from '../../img/Upwork.png'
// import Fiverr from '../../img/fiverr.png'
// import Amazon from '../../img/amazon.png'
// import Shopify from '../../img/Shopify.png'
// import Facebook from '../../img/Facebook.png'
import MachineLearning from '../../img/ml9.png'
import AI from '../../img/ai3.png'
import ReactIcon from '../../img/reacticon2.png'
import Node_Js from '../../img/node1.png'
import Web from '../../img/web1.png'
import { themeContext } from '../../Context'
import { useContext } from 'react'
import { motion } from 'framer-motion'
const Works = () => {
    const transition = {duration:2, type:'spring'};
    const theme = useContext(themeContext);
    const darkMode = theme.state.darkMode;
  return (
    
    <div className="works">
        {/*Left Side */}
        <div className="awesome">
            <span style={{color: darkMode? 'white' :''}}>Works in all these</span>
            <span>Latest Technologies</span>
            <spane>ReactJS Developer  
            <br />
            Machine Learning
            <br />
            Artificial Intelligence 
            <br />
            NodeJs
            </spane>
            <button className="button s-button">Hire me</button>
            <div className="blur s-blur1" style={{background:"#ABF1FF94"}}></div>
        </div>
        {/*Right Side */}
        <div className="w-right">
            <motion.div 
            initial={{rotate:45}}
            whileInView={{rotate:0}}
            viewport={{margin:'-40px'}}
            transition={{duration:3.5, type:'spring'}}
            className="w-mainCircle">
                <div className="w-secCircle">
                    <img src={ReactIcon} alt="" />
                </div>
                <div className="w-secCircle">
                    <img src={AI} alt="" />
                </div>
                <div className="w-secCircle">
                    <img src={Web} className="AI" alt="" />
                </div>
                <div className="w-secCircle">
                    <img src={MachineLearning} alt="" />
                </div>
                <div className="w-secCircle">
                    <img src={Node_Js} alt="" />
                </div>
                {/*Background Circle */}
                <div className="w-backCircle blueCircle"></div>
                <div className="w-backCircle yellowCircle"></div>
            </motion.div>
        </div>
    </div>
  )
}

export default Works